(() => {
  document.querySelectorAll('[data-helmet-product]').forEach(async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    await window.EvelRideMedia?.ready;
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);variants.forEach(v=>v.image=window.EvelRideMedia?.repairImage(v.sku)||v.image||window.EvelRideMedia?.image(v.sku));
    const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
    const available = variants;
    const finish = root.querySelector('[data-finish]');
    const size = root.querySelector('[data-size]');
    const id = root.querySelector('[data-variant-id]');
    const add = root.querySelector('[data-add]');
    const form = root.querySelector('form');
    const error = root.querySelector('[data-error]');
    let busy = false;
    function showPhoto(photo, label) {
      const media = root.querySelector('.er-hp-media');
      let image = media.querySelector('img');
      if (!image && photo) {
        image = document.createElement('img');
        image.width = 1000; image.height = 1000; image.loading = 'eager';
        media.prepend(image);
      }
      if (image) {
        image.hidden = !photo;
        if (photo) { image.removeAttribute('srcset'); image.src = photo; image.alt = label; media.querySelector('svg')?.remove(); }
      }
      const note = media.querySelector('p'); if (note) note.hidden = !!photo;
    }
    function fill(select, values, selected) {
      select.replaceChildren(...values.map(value => new Option(value, value)));
      if (values.includes(selected)) select.value = selected;
      select.disabled = !values.length;
    }
    function update() {
      const variant = available.find(v => v.finish === finish.value && v.size === size.value);
      id.disabled = !variant?.available; id.value = variant ? variant.id : '';
      add.disabled = !variant?.available || busy;
      add.textContent = busy ? labels.adding : variant?.available ? labels.add : labels.unavailable;
      root.querySelector('[data-stock]').textContent = variant?.available ? labels.available : labels.unavailable;
      root.querySelector('[data-sku]').textContent = variant ? variant.sku : '';
      if (variant) {
        const photo = variant.image || variants.find(v=>v.finish===variant.finish&&v.image)?.image;
        showPhoto(photo, variant.finish);
        root.querySelectorAll('[data-thumb-finish]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.thumbFinish===variant.finish)));
        root.querySelector('[data-price]').textContent = variant.price;
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
      }
      return variant?.available ? variant : null;
    }
    function sizes(selected) {
      fill(size, [...new Set(available.filter(v => v.finish === finish.value).map(v => v.size))].sort((a,b)=>['3XS','2XS','XS','S','M','L','XL','2XL','3XL','4XL','5XL'].indexOf(a)-['3XS','2XS','XS','S','M','L','XL','2XL','3XL','4XL','5XL'].indexOf(b)), selected);
      update();
    }
    const selected = available.find(v => String(v.id) === new URL(location.href).searchParams.get('variant')) || available[0];
    fill(finish, [...new Set(available.map(v => v.finish))], selected?.finish);
    const thumbs = root.querySelector('[data-helmet-thumbnails]');
    if(thumbs){for(const value of [...new Set(variants.map(v=>v.finish))]){
      const b=document.createElement('button');b.type='button';b.dataset.thumbFinish=value;
      const photo=variants.find(v=>v.finish===value&&v.image)?.image;
      if(photo){const img=document.createElement('img');img.src=photo.replace(/([?&])width=\d+/,'$1width=160');img.alt='';img.loading='lazy';b.append(img);}
      const label=document.createElement('span');label.textContent=value;b.append(label);
      const preview=()=>{if(photo)showPhoto(photo,value);};
      b.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')preview();});b.addEventListener('focus',preview);
      b.addEventListener('pointerleave',()=>update());b.addEventListener('blur',()=>update());
      b.addEventListener('click',()=>{finish.value=value;sizes(size.value);});thumbs.append(b);
    }}
    sizes(selected?.size);
    finish.addEventListener('change', () => sizes(size.value));
    size.addEventListener('change', update);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity() || !update()) return;
      error.hidden = true; busy = true; update();
      try {
        const response = await fetch(labels.addUrl, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || labels.error);
        location.assign(labels.cart);
      } catch (e) {
        error.textContent = e.message || labels.error; error.hidden = false;
        busy = false; update();
      }
    });
  });
})();


